export default __webpack_public_path__ + "static/media/Thumb_Shoes_06.c145e9f8.png";